
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { DraggableExerciseItem } from "./DraggableExerciseItem";

interface ExerciseDroppableContainerProps {
  exercises: any[];
  isPersonalPlan: boolean;
  showControls: boolean;
  canReorder: boolean;
  getCollapsedState: (exerciseId: string) => boolean;
  updateCollapsedState: (exerciseId: string, collapsed: boolean) => void;
  onDragStart: () => void;
  onDragEnd: (result: any) => void;
  onDeleteExercise: (exerciseId: string) => void;
  onUpdateExercise: (exerciseId: string, field: string, value: any) => void;
  onEditClick: (exercise: any) => void;
  isEditDialogOpen: boolean;
  editExerciseName: string;
  onEditNameChange: (name: string) => void;
  onEditDialogOpenChange: (open: boolean) => void;
  routineId: string;
}

export const ExerciseDroppableContainer = ({
  exercises,
  isPersonalPlan,
  showControls,
  canReorder,
  getCollapsedState,
  updateCollapsedState,
  onDragStart,
  onDragEnd,
  onDeleteExercise,
  onUpdateExercise,
  onEditClick,
  isEditDialogOpen,
  editExerciseName,
  onEditNameChange,
  onEditDialogOpenChange,
  routineId
}: ExerciseDroppableContainerProps) => {
  // Asegurar que los ejercicios estén ordenados por posición
  const sortedExercises = [...exercises].sort((a, b) => a.position - b.position);
  
  const droppableId = `exercises-${routineId}`;
  const shouldEnableDrag = canReorder && showControls;

  console.log("🎯 ExerciseDroppableContainer:", {
    exerciseCount: sortedExercises.length,
    isPersonalPlan,
    shouldEnableDrag,
    canReorder,
    showControls
  });

  // Si no se puede hacer drag, mostrar lista simple
  if (!shouldEnableDrag || sortedExercises.length === 0) {
    return (
      <div className="space-y-3">
        {sortedExercises.map((exercise, index) => (
          <DraggableExerciseItem
            key={`exercise-static-${exercise.id}`}
            exercise={exercise}
            index={index}
            isPersonalPlan={isPersonalPlan}
            showControls={showControls}
            canReorder={false}
            isCollapsed={getCollapsedState(exercise.id)}
            onDeleteExercise={onDeleteExercise}
            onUpdateExercise={onUpdateExercise}
            onEditClick={onEditClick}
            onCollapseChange={(collapsed) => updateCollapsedState(exercise.id, collapsed)}
            isEditDialogOpen={isEditDialogOpen}
            editExerciseName={editExerciseName}
            onEditNameChange={onEditNameChange}
            onEditDialogOpenChange={onEditDialogOpenChange}
          />
        ))}
      </div>
    );
  }

  return (
    <DragDropContext onDragStart={onDragStart} onDragEnd={onDragEnd}>
      <Droppable droppableId={droppableId}>
        {(provided, snapshot) => (
          <div 
            ref={provided.innerRef}
            {...provided.droppableProps}
            className={`
              space-y-3 transition-all duration-200 rounded-lg
              ${snapshot.isDraggingOver ? 'bg-[#00C1D6]/10 p-2' : ''}
            `}
          >

            {sortedExercises.map((exercise, index) => (
              <DraggableExerciseItem
                key={`exercise-draggable-${exercise.id}`}
                exercise={exercise}
                index={index}
                isPersonalPlan={isPersonalPlan}
                showControls={showControls}
                canReorder={shouldEnableDrag}
                isCollapsed={getCollapsedState(exercise.id)}
                onDeleteExercise={onDeleteExercise}
                onUpdateExercise={onUpdateExercise}
                onEditClick={onEditClick}
                onCollapseChange={(collapsed) => updateCollapsedState(exercise.id, collapsed)}
                isEditDialogOpen={isEditDialogOpen}
                editExerciseName={editExerciseName}
                onEditNameChange={onEditNameChange}
                onEditDialogOpenChange={onEditDialogOpenChange}
              />
            ))}
            
            {provided.placeholder}


          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};
